var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSuccessClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 115,
    viewBox: "0 0 139 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18.666C25.9288 18.666 17 27.5948 17 38.166C17 48.7372 25.9288 57.666 36.5 57.666C47.0712 57.666 56 48.7372 56 38.166C56 27.5948 47.0712 18.666 36.5 18.666ZM36.5 53.3327C28.2797 53.3327 21.3333 46.3864 21.3333 38.166C21.3333 29.9457 28.2797 22.9993 36.5 22.9993C44.7203 22.9993 51.6667 29.9457 51.6667 38.166C51.6667 46.3864 44.7203 53.3327 36.5 53.3327Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6663 36.0006V27.334H34.333V40.334H47.333V36.0006H38.6663Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9492 18.0309L51.0085 14.9629L57.5302 21.4629L54.4687 24.5331L47.9492 18.0309Z",
    fill: "#565656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0126 18.0322L18.5342 24.53L15.4619 21.4707L21.9402 14.9707L25.0126 18.0322Z",
    fill: "#565656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 115C70.1995 115 50.5 95.3005 50.5 71C50.5 46.6995 70.1995 27 94.5 27C118.801 27 138.5 46.6995 138.5 71C138.5 95.3005 118.801 115 94.5 115Z",
    fill: "#74BF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1774 95.4589C86.2509 95.4589 84.3245 94.6333 83.2236 92.9821L67.8117 73.1666C65.6099 70.4145 66.1605 66.5616 68.9126 64.3598C71.6647 62.158 75.5176 62.7086 77.7194 65.4607L88.1774 78.9462L111.296 48.9477C113.497 46.1956 117.35 45.6451 120.102 47.8468C122.855 50.0486 123.405 53.9016 121.203 56.6537L93.1313 92.9819C91.7553 94.3582 90.104 95.4589 88.1774 95.4589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSuccessClock);
export default __webpack_public_path__ + "static/media/icons-success-clock.9f6ff1519b3e412377477c537215982a.svg";
export { ForwardRef as ReactComponent };